<template>
  <Modal v-if="showModalPickedUpReservation" @close="$emit('closeModal')">
    <div class="pickedUpReservation">
      <div class="pickedUpReservation__header">
        <p class="text">
          {{ $t('pickedUpRevervation') }}
        </p>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt="CloseModal"
          @click="$emit('closeModal')"
        />
      </div>
      <div class="pickedUpReservation__buttons">
        <Button
          variant="filled"
          :title="$t('yes')"
          @click="$emit('pickedUpReservationRequest', idDelivery)"
        />
        <Button
          variant="notBordered"
          :title="$t('no')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'PickedUpReservation',
  props: ['showModalPickedUpReservation', 'idDelivery']
})
export default class PickedUpReservation extends Vue {}
</script>

<style lang="scss" scoped>
.pickedUpReservation {
  width: 460px;
  height: 100%;
  padding: 24px;
  .pickedUpReservation__header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 24px;
    .text {
      color: $label;
      font-size: $fourteenSize;
      line-height: $twentyTwoSize;
      font-weight: 500;
    }
    img {
      cursor: pointer;
    }
  }
}
</style>
